module.exports = __webpack_public_path__ + "static/img/main_logo.c672a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main_logo.png
// module id = 3ZpY
// module chunks = 0